export const GET_CUSTOMER_NOTIFICATION = 'GET_CUSTOMER_NOTIFICATION';
export const GET_MORE_CUSTOMER_NOTIFICATION = 'GET_MORE_CUSTOMER_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const SET_NOTIFICATION_TAPPED = 'SET_NOTIFICATION_TAPPED';